import { SpaceBetween } from '@amzn/awsui-components-react';
import { ClassTypeBadge } from './ClassTypeBadge';
import { TsaLinkedBadge } from './TsaLinkedBadge';
import { CloudQuestBadge } from './CloudQuestBadge';
import { ProxyRegisteredBadge } from './ProxyRegisteredBadge';
import React from 'react';
import { FlagNames, isFeatureEnabled, Stages } from '@amzn/aws-tc-ilt-common';
import { CONTENT_TYPE_CLOUD_QUEST, getNodeEnvironment } from '../../common';
import { ContentConfig } from '../../common/types';

export function CourseBadges({
    item,
}: {
    item: { activityModality: string; isProxy: boolean; learningGoalIds?: string[]; contentConfigs?: ContentConfig[] };
}) {
    const isTsaLearningGoalEnabled = isFeatureEnabled(FlagNames.TSA_P0_LEARNING_GOAL, getNodeEnvironment() as Stages);
    const isBoltOnCloudQuestEnabled = isFeatureEnabled(FlagNames.BOLT_ON_CLOUD_QUEST, getNodeEnvironment() as Stages);

    const isBoltOnClass = !!isBoltOnCloudQuestEnabled && !!item.contentConfigs?.some((c) => c.content_type === CONTENT_TYPE_CLOUD_QUEST);

    return (
        <SpaceBetween size='xs' direction='horizontal'>
            <ClassTypeBadge item={item} />
            {isTsaLearningGoalEnabled && <TsaLinkedBadge item={item} />}
            {isBoltOnClass && <CloudQuestBadge isBoltOnClass={isBoltOnClass} />}
            {item.isProxy ? <ProxyRegisteredBadge /> : <></>}
        </SpaceBetween>
    );
}
